/* 🤖 this file was generated by svg-to-ts */
export const matIconFolder: {
  name: 'folder';
  data: string;
} = {
  name: 'folder',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m9.17 6 2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/></svg>`
};
